var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-popup",
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.$refs.filialsettingspopover.$emit("close")
        },
      },
    },
    [
      _c(
        "button",
        {
          staticClass: "c-popup-button",
          attrs: {
            id: `filial-settings-popup-${_vm.postCode}-${_vm.cellIndex}`,
          },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "2",
                height: "13",
                viewBox: "0 0 2 13",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M1 1L1 7M1 11L1 12",
                  stroke: "#12C971",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
            ]
          ),
        ]
      ),
      _c(
        "b-popover",
        {
          ref: "filialsettingspopover",
          attrs: {
            id: "positions-filial-settings-popup",
            triggers: "click",
            placement: "bottomright",
            target: `filial-settings-popup-${_vm.postCode}-${_vm.cellIndex}`,
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "c-popup-close",
              attrs: {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                  fill: "#8E9CBB",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          ),
          _c("h3", { staticClass: "c-popup-title" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _c(
            "div",
            {
              staticClass: "c-popup-list",
              class: { "c-popup-list-scrollable": _vm.scrollable },
            },
            _vm._l(_vm.popupItems, function (item) {
              return _c(
                "div",
                { key: item.name, staticClass: "c-popup-list-item" },
                [
                  _c("div", [_vm._v(_vm._s(item.name))]),
                  _c("div", { staticClass: "c-popup-list-item-value" }, [
                    _vm._v(_vm._s(item.value)),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm.scrollable
            ? _c("div", { staticClass: "c-popup-list-shadow" })
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }